import React, { useState } from "react";
import styled from "styled-components";
import colors from "../constatns/colors";
import useWindowDimensions from "../constatns/size";

import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';

// import "../styles/home.css";
import RoadMapCard from "../components/RoadMapCard";
import GrTitle, { Title } from "../components/BgTitle";

function LinearProgressWithLabel(props) {
    const { width } = props;
    return (
      <Box sx={{ width: props.width * 0.74 }}>
        <Box sx={{ width: width <= 768 ? "310%" : '100%', mr: 1, position: "relative" }}>
            <LinearProgress color="primary" style={{height: 10, borderRadius: 5 , backgroundColor: colors.grey, color: colors.btnPrimary }} {...props}  variant="determinate"/>
            <div style={{position: "absolute", 
                backgroundColor: colors.btnPrimary, height: 10,
                width: width <= 768 ? "60%" : '60%', top: 0,
                borderRadius: 10,
            }}></div>
        </Box>
      </Box>
    );
  }

  function VerticalLinearProgressWithLabel(props) {
    const { width, height } = props;
    return (
      <Box sx={{width: 50}}>
        <Box sx={{ width: 10, height: 700 , mr: 1, position: "relative", alignSelf: "center"}}>
            <LinearProgress color="primary" style={{ height: 700, borderRadius: 5 , backgroundColor: colors.grey, color: colors.btnPrimary }} {...props}  variant="determinate"/>
            <div style={{position: "absolute", 
                backgroundColor: colors.btnPrimary, height: 10,
                height: '59.5%', width: 10, top: 0,
                borderRadius: 10,
            }}></div>
        </Box>
      </Box>
    );
  }

function RoadMap() {
    const { width, height } = useWindowDimensions();
    const [value, setValue] = useState(0)
  return (
      <div id="roadmap">
            <GrTitle bgTitle={"TIMELINE"} />
            <Title title={"ROAD MAP"} />
        { width <= 768 ? 
        <Container width={width} height={height} style={{display: "flex", flexDirection: "row"}} >
            <InnerContainer style={{display: "block"}}>
                <RoadMapCard
                    containerStyle={{}}
                    title={"Q4 2022:"}
                    descriptionOne={"Platform under development as of Sept 2022."}
                    descriptionTwo={"Token Deployment to the Mainnet."}
                    descriptionThree={"GearChain platform Proof of Concept and Framework."}
                    innerContainerStyle={{textAlign: "left", marginTop: 5}}
                    isRed={true}
                />
                <RoadMapCard
                    title={"Q2 2023:"}
                    descriptionOne={"Testing and Release of GearChain platform v1.0 "}
                    descriptionTwo={"Partnering to extend the ecosystem through pilot projects, including government-mandated compliance and NFT."}
                    innerContainerStyle={{textAlign: "left", marginTop: 5}}
                    isRed={true}
                />
                <RoadMapCard
                    title={"Q4 2023:"}
                    descriptionOne={"Expansion of partnerships and initiation of pilot projects to expand the ecosystem."}
                    innerContainerStyle={{ marginTop: 47, textAlign: "left"}}
                    isRed={false}
                />
            </InnerContainer>
            <InnerContainer style={{width: "1%"}}>
                {/* <Slider defaultValue={50} step={6} aria-label="Default" valueLabelDisplay="auto" /> */}
                {/* <div class="slidecontainer"> */}
                    {/* <input onInput={()=> {}} type="range" min="0" max="100" value={value} class="slider" id="myRange"/> */}
                    <VerticalLinearProgressWithLabel width={width} height={height} value={value} />
                {/* </div> */}
            </InnerContainer>

            
            <InnerContainer style={{ display: "block"}}>
                <RoadMapCard
                    containerStyle={{ zIndex: 1}}
                    rightBorder
                    title={"Q1 2023:"}
                    descriptionOne={"Token Generation Event Private/Pre-sales."}
                    descriptionTwo={"Release of GearChain Platform(Beta)."}
                    isRed={true}
                />
                <RoadMapCard
                    title={"Q3 2023:"}
                    rightBorder
                    descriptionOne={"GearChain v.2.0 with IoT, Edge computing expansion."}
                    isRed={true}
                    containerStyle={{zIndex: 1}}
                />
                <RoadMapCard
                    title={"Q2 2024:"}
                    rightBorder
                    descriptionOne={"Extensive custom projects for 3/4/5PLs and large suppliers, shippers."}
                    isRed={false}
                    containerStyle={{zIndex: 1}}
                />
            </InnerContainer> 
        </Container>
        :
        // mobile
        <Container width={width} height={height} >
            <InnerContainer style={{marginBottom: 15}}>
                <RoadMapCard
                    containerStyle={{marginLeft: 0, zIndex: 1}}
                    topBorder
                    title={"Q1 2023:"}
                    descriptionOne={"Token Generation Event Private/Pre-sales."}
                    descriptionTwo={"Release of GearChain Platform(Beta)."}
                    isRed={true}
                />
                <RoadMapCard
                    title={"Q3 2023:"}
                    topBorder
                    descriptionOne={"GearChain v.2.0 with IoT, Edge computing expansion."}
                    isRed={true}
                    containerStyle={{zIndex: 1}}
                />
                <RoadMapCard
                    title={"Q2 2024:"}
                    topBorder
                    descriptionOne={"Extensive custom projects for 3/4/5PLs and large suppliers, shippers."}
                    isRed={false}
                    containerStyle={{zIndex: 1}}
                />
            </InnerContainer> 
            <InnerContainer>
                {/* <Slider defaultValue={50} step={6} aria-label="Default" valueLabelDisplay="auto" /> */}
                <div class="slidecontainer">
                    {/* <input onInput={()=> {}} type="range" min="0" max="100" value={value} class="slider" id="myRange"/> */}
                    <LinearProgressWithLabel width={width} value={value} />
                </div>
            </InnerContainer>

            <InnerContainer style={{marginTop: 20}}>
                <RoadMapCard
                    containerStyle={{marginLeft: 0}}
                    title={"Q4 2022:"}
                    descriptionOne={"Platform under development as of Sept 2022."}
                    descriptionTwo={"Token Deployment to the Mainnet."}
                    descriptionThree={"GearChain platform Proof of Concept and Framework."}
                    innerContainerStyle={{textAlign: "left", marginTop: 5}}
                    isRed={true}
                />
                <RoadMapCard
                    title={"Q2 2023:"}
                    descriptionOne={"Testing and Release of GearChain platform v1.0 "}
                    descriptionTwo={"Partnering to extend the ecosystem through pilot projects, including government-mandated compliance and NFT."}
                    innerContainerStyle={{textAlign: "left", marginTop: 5}}
                    isRed={true}
                />
                <RoadMapCard
                    title={"Q4 2023:"}
                    descriptionOne={"Expansion of partnerships and initiation of pilot projects to expand the ecosystem."}
                    innerContainerStyle={{ marginTop: 47, textAlign: "left"}}
                    isRed={false}
                />
            </InnerContainer>
        </Container>
        }
    </div>
  );
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    padding-left: ${({width})=> width * 0.1}px;
    padding-right: ${({width})=> width * 0.1}px;
    margin-top: ${({height})=> height * 0.1}px;
    padding-bottom: 50px;
    align-items: center;

`

const InnerContainer = styled.div`
    display: flex;
    margin-top: ${({height})=> height * 0.1}px ;
    color: ${colors.white};
    width: 90%;

    @media (max-width: 768px) {
        /* width: 120%; */
        
    }

`

export default RoadMap;
